export default "<div class=\"issue-text d-flex justify-content-center\">\n  <h1>Errore durante l'elaborazione della richiesta</h1>\n</div>\n";